export const INPUT_TYPE_MAP = {
    0: 'Text',
    1: 'Radio',
    2: 'Select',
    3: 'File',
    4: 'Number',
    5: 'Checkbox',
    6: 'Date',
    7: 'Time',
    8: 'DateTime',
    9: 'Image',
    10: 'URL',
    11: 'TextArea',
    12: 'Hidden',
    13: 'Password',
    14: 'Color'
};

export const INPUT_TYPE_REVERSE_MAP = {
    'Text': 0,
    'Radio': 1,
    'Select': 2,
    'File': 3,
    'Number': 4,
    'Checkbox': 5,
    'Date': 6,
    'Time': 7,
    'DateTime': 8,
    'Image': 9,
    'URL': 10,
    'TextArea': 11,
    'Hidden': 12,
    'Password': 13,
    'Color': 14
};

export const getInputTypeString = (type) => {
    return INPUT_TYPE_MAP[type] || 'Text';
}

export const getInputTypeNumeric = (type) => {
    return INPUT_TYPE_REVERSE_MAP[type] || 0;
}